export default __webpack_public_path__ + "static/media/up.f1453f5d.svg";